import React from 'react'
import PromoUpdate from '../promo_components/promo_update'
import WebSidebar from '../../web_sidebar'
export default function
    () {
    return (
        <div>
            <div className='row'>

                <WebSidebar />


                <div className='content-wrapper w-75 bg-white p-5'>
                    <div>
                        <h2>Update Promotion</h2>
                        <PromoUpdate />
                    </div>


                </div>
            </div>




        </div>
    )
}
